module.exports = __webpack_public_path__ + "img/sfks2-3.865f9b26.png";